import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import PartnerStudentVariationGauge from './PartnerStudentVariationGauge';
import CustomerSuccessHistoryService from '../../services/CustomerSuccessHistoryService';
import { PartnerStudentVariationListService } from '../../services/CustomerSuccessKpiListService';

class PartnerStudentVariationGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    PartnerStudentVariationListService.load();
  }

  render() {
    return (
      <PartnerStudentVariationGauge
        loading={
          PartnerStudentVariationListService.fetchCurrent.fetching ||
          PartnerStudentVariationListService.fetchPrevious.fetching
        }
        currentValue={toJS(PartnerStudentVariationListService.global.current)}
        previousValue={toJS(PartnerStudentVariationListService.global.previous)}
        onClickHistory={() => CustomerSuccessHistoryService.openDialog('PARTNER_STUDENT_VARIATION')}
        formatter={PartnerStudentVariationListService.getFormattedValue}
      />
    );
  }
}

export default observer(PartnerStudentVariationGaugeContainer);
